import * as yup from 'yup';

export const LoginMaintenanceValidationSchema = yup.object().shape({
    codice: yup.string().required('id is required').min(2, 'id is too short').max(30, 'id is too long'),
});
export const loginMaintenanceFormDefaultValue = {
    codice: '',
}